import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyCTA } from './components/StickyCTA';
import { UrgencyBar } from './components/UrgencyBar';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-text selection:bg-brand-green/20" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <StatsBar data-id="element-5" />
        <TransformationSection data-id="element-6" />
        <PainPointsSection data-id="element-7" />
        <KitContentsSection data-id="element-8" />
        <InstantAccessSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <AboutSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTASection data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
      <StickyCTA data-id="element-19" />
    </div>;
}